import { formProperties } from '@js/utils/formProperties';

/**
 * $formProperties(form): a product form's line item properties as { name: value } (see utils/formProperties).
 * Used by the product form's dynamic checkout form to carry the main form's properties into Shop Pay.
 */
export default {
  name: 'formProperties',
  magic: () => (form) => formProperties(form),
};
